import React, { useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom"; // ✅ import useNavigate
import { FaFacebook, FaInstagram, FaTiktok } from 'react-icons/fa';
import './Service.css';

const Service = () => {
  const navigate = useNavigate(); // ✅ navigation hook

  // ✅ function to go to navigation page
  const goToNavigation = () => {
    navigate('/navigation'); // make sure your route path in App.jsx is "/navigation"
  };

  // ✅ When the component loads, scroll to top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Header */}
        <header className="header-top">
          <div className="header-left">
            <img src="/logo.jpg" alt="Zhufu Logo" className="header-logo" />
          </div>

          <div className="header-right">
            <nav className="nav-links">
              <Link to="/">Home</Link>
              <Link to="/about">About</Link>
              <Link to="/services">Services</Link>
              <Link to="/gallery">Gallery</Link>
              <Link to="/contact">Contact</Link>
            </nav>

            {/* ✅ Menu Button */}
            <button className="menu-btn" onClick={goToNavigation}>
              <span className="bar"></span>
              <span className="bar"></span>
              <span className="bar"></span>
            </button>
          </div>
        </header>
      {/* Services Section */}
      <section className="services-page">

        <div className="services-container">
          <h1 className="team-title">Meet the Team</h1>
          <p className="team-subtitle">
            At Zhufu Agency, we specialize in providing exceptional hospitality and event support services that bring elegance, efficiency, and excellence to every occasion. We boast a dynamic team of over 30 highly skilled and experienced professionals, comprising waiters, waitresses, ushers, bartenders, hostesses, registration crew, and chefs. Our diverse team is equipped to deliver exceptional service and support for a wide range of events and functions.
          </p>

          {/* Team Photo */}
          <div className="team-photo-container">
            <img src="https://res.cloudinary.com/dd2jk2uv2/image/upload/v1761935151/zhufu_team_u6z6lt.jpg" alt="Zhufu Team" className="team-photo" loading="lazy" />
          </div>

          {/* Ushers Section */}
          <div className="service-category">
            <h2>Ushers</h2>
            <p className="category-description">
              Our ushers are the first point of contact for every guest, setting the tone for excellence from the moment they arrive. Trained to be warm, attentive, and professional, they guide guests with confidence, assist with seating, and ensure the event runs smoothly. Their welcoming presence reflects Zhufu’s commitment to grace, order, and hospitality.
            </p>
            <div className="team-grid">
              <div className="staff-card">
                <img src="/photos/tlotli.jpg" alt="Tlotlo" className="team-box" loading="lazy" />
                <h3>Tlotli</h3>
              </div>
              <div className="staff-card">
                <img src="/photos/okuhle.jpg" alt="Okuhle" className="team-box" loading="lazy" />
                <h3>Okuhle</h3>
              </div>
              <div className="staff-card">
                <img src="/photos/smanga.jpg" alt="Smanga" className="team-box" loading="lazy" />
                <h3>Smanga</h3>
              </div>
            </div>
          </div>

          {/* Hostess Section */}
          <div className="service-category">
            <h2>Hostesses</h2>
            <p className="category-description">
              Our hostesses embody elegance, professionalism, and warmth. They ensure every guest feels valued and comfortable throughout the event. From coordinating seating arrangements to assisting with guest inquiries, our hostesses maintain a calm, organized atmosphere while representing Zhufu’s standard of excellence and care.
            </p>
            <div className="team-grid">
              <div className="staff-card">
                <img src="/photos/lethaboM.jpg" alt="Lethabo" className="team-box" loading="lazy" />
                <h3>Lethabo M</h3>
              </div>
              <div className="staff-card">
                <img src="/photos/katlego.jpg" alt="Katlego" className="team-box" loading="lazy" />
                <h3>Katlego</h3>
              </div>
              <div className="staff-card">
                <img src="/photos/angel.jpg" alt="Angel" className="team-box" loading="lazy" />
                <h3>Angel</h3>
              </div>
            </div>
          </div>

          {/* Waiters Section */}
          <div className="service-category">
            <h2>Waiters and Waitresses</h2>
            <p className="category-description">
              Our waiters and waitresses provide exceptional service with warmth and professionalism. They ensure guests are comfortable, orders are served promptly, and every dining experience feels smooth and enjoyable.
            </p>
            <div className="team-grid">
              <div className="staff-card">
                <img src="/photos/prides.jpg" alt="Tlotlo" className="team-box" loading="lazy" />
                <h3>Pride</h3>
              </div>
              <div className="staff-card">
                <img src="/photos/namhlas.jpg" alt="Okuhle" className="team-box" loading="lazy" />
                <h3>Namhla</h3>
              </div>
              <div className="staff-card">
                <img src="/photos/thapi.jpg" alt="Thapi" className="team-box" loading="lazy" />
                <h3>Thapi</h3>
              </div>
            </div>
          </div>

          {/* Bartenders Section */}
          <div className="service-category">
            <h2>Bartenders</h2>
            <p className="category-description">
              Our bartenders bring skill, creativity, and professionalism to every event. Trained to craft both classic and custom beverages, they serve with precision and charm, ensuring each guest enjoys a refreshing experience.
            </p>
            <div className="team-grid">
              <div className="staff-card">
                <img src="/photos/tumelo.jpg" alt="Tumelo" className="team-box" loading="lazy" />
                <h3>Tumelo</h3>
              </div>
              <div className="staff-card">
                <img src="/photos/lesedi.jpg" alt="Lesedi" className="team-box" loading="lazy" />
                <h3>Lesedi</h3>
              </div>
              <div className="staff-card">
                <img src="/photos/thato.jpg" alt="Thato" className="team-box" loading="lazy" />
                <h3>Thato</h3>
              </div>
            </div>
          </div>

          {/* Runners Section */}
          <div className="service-category">
            <h2>Runners</h2>
            <p className="category-description">
              Our runners are the backbone of every successful event. They work diligently behind the scenes to ensure everything runs smoothly — from setting up and replenishing supplies to assisting the serving team wherever needed. Their speed, reliability, and teamwork keep operations seamless, reflecting Zhufu’s dedication to efficiency and excellence in every detail.
            </p>
            <div className="team-grid">
              <div className="staff-card">
                <img src="/photos/muhali.jpg" alt="Muhali" className="team-box" loading="lazy" />
                <h3>Muhali</h3>
              </div>
              <div className="staff-card">
                <img src="/photos/thapi.jpg" alt="Thapi" className="team-box" loading="lazy" />
                <h3>Thapi</h3>
              </div>
              <div className="staff-card">
                <img src="/photos/lethaboT.jpg" alt="Lethabo T" className="team-box" loading="lazy" />
                <h3>Lethabo T</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer Section */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-left">
            <h3>ZHUFU AGENCY</h3>
            <p>
              Welcome to Zhufu Agency, your premier partner for exceptional event staffing solutions. We specialize in outsourcing skilled and professional waiters, ushers, bartenders, hostesses, registration crew, and runners to ensure seamless execution of your events.
            </p>

            {/* ✅ Social Icons */}
            <div className="social-icons">
              <a href="https://www.tiktok.com/@zhufuangency?_t=ZS-8z2JfPdP5RX&_r=1" target="_blank" rel="noopener noreferrer">
                <FaTiktok />
              </a>
              <a href="https://www.instagram.com/zhufuagency?igsh=MXJwZDMzdWVpcG9kbg%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>
              <a href="https://www.facebook.com/zhufuagency" target="_blank" rel="noopener noreferrer">
                <FaFacebook />
              </a>
            </div>
          </div>

          <div className="footer-right">
            <h3>QUICK LINKS</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div>
            <h4>CONTACT US</h4>
            <p>
              Email Us: <a href="mailto:Zhufuagency1@gmail.com">Zhufuagency1@gmail.com</a>
            </p>
            <p>
              Call Us: <a href="tel:0659966846">065 996 6846</a>
            </p>
          </div>
          <p className="credits">© 2025 Zhufu. All rights reserved.</p>
        </div>
      </footer>
    </>
  );
};

export default Service;
